import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./ui/alert-dialog";

export const ProductDeleteDialog = ({ product, onCancel, onConfirm }) => {
  const recipes = product?.linked_recipes || [];
  return (
    <AlertDialog open={!!product} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <AlertDialogContent data-testid="product-delete-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Supprimer « {product?.name} » ?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2 text-sm text-[#5E6875]">
              {recipes.length > 0 ? (
                <div data-testid="product-delete-recipes-warning" className="rounded-md border border-amber-300 bg-amber-50 p-3 text-amber-900">
                  <p className="font-medium">Ce produit est utilisé dans {recipes.length} recette{recipes.length > 1 ? "s" : ""} :</p>
                  <ul className="mt-1 list-disc pl-5">
                    {recipes.map((r) => <li key={r.id}>{r.name}</li>)}
                  </ul>
                  <p className="mt-2">Il sera retiré de ces recettes : leur coût matière et leur marge seront recalculés sans cet ingrédient.</p>
                </div>
              ) : (
                <p>Ce produit n'est utilisé dans aucune recette.</p>
              )}
              <p>Cette action est définitive.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="product-delete-cancel">Annuler</AlertDialogCancel>
          <AlertDialogAction data-testid="product-delete-confirm" onClick={onConfirm} className="bg-red-600 hover:bg-red-700">
            Supprimer
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
